module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dawn professional photo.eec0f94d.png";